export enum IdType {
  MyKad = 1,
  MyPR = 7,
  Passport = 2
}
